// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1btgV","footer":"styles_footer__14jhe","passCodeTooltip":"styles_passCodeTooltip__qqbns"};